import { useQuery } from "@tanstack/react-query";
import { fetchTargetGroupsLvl1 } from "api/targetGroups/fetchTargetGroupsLvl1";

export function useFetchTargetGroupsLvl1() {
    const { data, error, isLoading, refetch } = useQuery({
        queryKey: ["targetGroups/level1"],
        queryFn: fetchTargetGroupsLvl1,
    });

    return {
        targetGroupsLvl1: data || [],
        targetGroupsLvl1Error: error,
        targetGroupsLvl1IsLoading: isLoading,
        refetchTargetGroupsLvl1: refetch,
    };
}
